import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    standalone: false
})
export class ErrorPageComponent implements OnInit {

  CurentRoute: any;
  targetUrl: any;
  timeNow = new Date();
  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.targetUrl = this.router.getCurrentNavigation()?.extras?.state?.Path;
  }

  ngOnInit(): void {
  }

}
